module.exports = __webpack_public_path__ + "img/code.c6bb098e.svg";